import { ArcElement, Chart as ChartJS, Tooltip } from 'chart.js';
import React, { useEffect, useRef, useState } from 'react';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip);

const PieChart = ({ outerChartData }) => {
  const chartRef = useRef(null);
  const [size, setSize] = useState('180px');

  useEffect(() => {
    const updateSize = () => {
      if (chartRef.current) {
        const parentWidth = chartRef.current.parentElement.offsetWidth;
        const newSize = Math.max(parentWidth, 180) * 0.5; // Limit max size to 180px
        setSize(`${newSize}px`);
        chartRef.current.style.height = `${newSize}px`; // Explicitly set height
      }
    };

    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);


  const percentage = outerChartData?.readinessPercentage || 0;
  const roundedPercentage = Math.round(percentage * 100 )/100;

  // Determine color based on percentage value
  const getColorByPercentage = percentage => {
    if (percentage <= 25) return ['#FF0000', '#FFE1E1']; // Light Blue
    if (percentage <= 50) return ['#FF7171', '#FFE7E7']; // Lime Green
    if (percentage <= 75) return ['#FFCC00', '#FFEC9B']; // Deep Orange
    if (percentage <= 100) return ['#196B24', '#D9F2D0']; // Purple
    return ['#1E88E5', '#BBDEFB']; // Rich Blue
  };

  const randomColors = getColorByPercentage(roundedPercentage);

  const data = {
    labels: [],
    datasets: [
      {
        data: [roundedPercentage, 100 - roundedPercentage],
        backgroundColor: randomColors,
        hoverBackgroundColor: randomColors.map(color => color),
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    cutout: '70%', // Converts the pie chart into a donut chart
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false, // Disable tooltips
      },
    },
  };

  return (
    <div
      ref={chartRef}
      style={{ position: 'relative', height: '500px', width: size }}
    >
      <Pie
        data={data}
        options={options}
        style={{ height: size, width: size }}
      />
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '16px',
          fontWeight: 'bold',
          color: randomColors[0],
        }}
      >
        {roundedPercentage}%
      </div>
    </div>
  );
};

export default PieChart;
